import PokemonSearch from '../components/pokemon/PokemonSearch';

const Home = () => <PokemonSearch />;

export default Home;
